import { NgModule, Injectable } from '@angular/core';
import { RouterModule, Routes, DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { SettingsComponent } from './components/settings/settings.component';
import { AboutComponent } from './components/about/about.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { Utilities } from './services/utilities';
import { AgentChatComponent } from './components/agent-chat/agent-chat.component';
import { SfIcdReportComponent } from './components/sf-icd-report/sf-icd-report.component';
import { SfIcdCreateComponent } from './components/sf-icd-create/sf-icd-create.component';
import { SfIcdDetailComponent } from './components/sf-icd-detail/sf-icd-detail.component';
import { SfIcdAcknowledgeComponent } from './components/sf-icd-acknowledge/sf-icd-acknowledge.component';
import { SfIcdAddlocationComponent } from './components/sf-icd-addlocation/sf-icd-addlocation.component';
import { SfIcdCampmaintainComponent } from './components/sf-icd-campmaintain/sf-icd-campmaintain.component';
import { SfIcdChangeOfficeInfoComponent } from './components/sf-icd-change-office-info/sf-icd-change-office-info.component';
import { SfIcdHubMaintainComponent } from './components/sf-icd-hub-maintain/sf-icd-hub-maintain.component';
import { SfIcdCloselocationComponent } from './components/sf-icd-closelocation/sf-icd-closelocation.component';
import { SfIcdInfoComponent } from './components/sf-icd-info/sf-icd-info.component';
import { SfIcdMoveLocationComponent } from './components/sf-icd-move-location/sf-icd-move-location.component';
import { SfIcdOffcCampComponent } from './components/sf-icd-offc-camp/sf-icd-offc-camp.component';
import { SfIcdTerminateContractComponent } from './components/sf-icd-terminate-contract/sf-icd-terminate-contract.component';
import { SfIcdMoreComponent } from './components/sf-icd-more/sf-icd-more.component';
import { SfIcdCampaignmasterComponent } from './components/sf-icd-campaignmaster/sf-icd-campaignmaster.component';
import { SfIcdChangerequestComponent } from './components/sf-icd-changerequest/sf-icd-changerequest.component';
import { SfIcdCampaignparticipationComponent } from './components/sf-icd-campaignparticipation/sf-icd-campaignparticipation.component';
import { SfIcdReopenicdComponent } from './components/sf-icd-reopenicd/sf-icd-reopenicd.component';
import { SfIcdInactiveComponent } from './components/sf-icd-inactive/sf-icd-inactive.component';
import { EmaillogsComponent } from './components/emaillogs/emaillogs.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { ScpaymentsComponent } from './components/scpayments/scpayments.component';
import { SfHelpInformationComponent } from './components/sf-help-information/sf-help-information.component';
import { HubReportUploadComponent } from './components/hub-report-upload/hub-report-upload.component';
import { HelpfulContactsMaintenanceComponent } from './components/helpful-contacts-maintenance/helpful-contacts-maintenance.component';
import { NetsuiteLedgerComponent } from './components/netsuite-ledger/netsuite-ledger.component';

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const possibleSeparators = /[?;#]/;
    const indexOfSeparator = url.search(possibleSeparators);
    let processedUrl: string;

    if (indexOfSeparator > -1) {
      const separator = url.charAt(indexOfSeparator);
      const urlParts = Utilities.splitInTwo(url, separator);
      urlParts.firstPart = urlParts.firstPart;

      processedUrl = urlParts.firstPart + separator + urlParts.secondPart;
    } else {
      processedUrl = url;
    }

    return super.parse(processedUrl);
  }
}


const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard], data: { title: 'Home' } },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
 
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard], data: { title: 'Settings' } },
  { path: 'admin-query', component: AgentChatComponent, canActivate: [AuthGuard], data: { title: 'Admin Query Agent' } },
  { path: 'icdreport', component: SfIcdReportComponent, canActivate: [AuthGuard], data: { title: 'Distributors' } },
  { path: 'campaignmaster', component: SfIcdCampaignmasterComponent, canActivate: [AuthGuard], data: { title: 'Campaigns' } },
  { path: 'campaignparticipation', component: SfIcdCampaignparticipationComponent, canActivate: [AuthGuard], data: { title: 'Participation' } },
  { path: 'changerequest', component: SfIcdChangerequestComponent, canActivate: [AuthGuard], data: { title: 'Requests' } },
  { path: 'help', component: SfHelpInformationComponent, canActivate: [AuthGuard], data: { title: 'Help Information' } },
  { path: 'admin/helpful-contacts', component: HelpfulContactsMaintenanceComponent, canActivate: [AuthGuard], data: { title: 'Helpful Contacts' } },
  { path: 'emaillog', component: EmaillogsComponent, canActivate: [AuthGuard], data: { title: 'Email Logs' } },
  { path: 'hubreportupload', component: HubReportUploadComponent, canActivate: [AuthGuard], data: { title: 'LT Report Upload' } },
  { path: 'mfa-setup', component: MfaSetupComponent, data: { title: 'mfa-setup' } },
  { path: 'scpayments', component: ScpaymentsComponent, canActivate: [AuthGuard], data: { title: 'SC Payments' } },

  
  { path: 'icd', canActivate: [AuthGuard], component: SfIcdCreateComponent,data: { title: 'New ICD' } },
  
  {
    path: 'icddetail', component: SfIcdDetailComponent,
    children: [
      { path: '', redirectTo: 'icdinfo', pathMatch: 'full' },
      { path: 'icdinfo/:id/:query', component: SfIcdInfoComponent, data: { title: 'ICD Info' } },
      { path: 'icdinfo/:id', component: SfIcdInfoComponent, canActivate: [AuthGuard], data: { title: 'ICD Info' } },

      { path: 'offcamp/:id', component: SfIcdOffcCampComponent, canActivate: [AuthGuard], data: { title: 'Office Camp' } },
      { path: 'offcamp/:id/:query', component: SfIcdOffcCampComponent, canActivate: [AuthGuard], data: { title: 'Office Camp' } },

      { path: 'acknowledge/:id', component: SfIcdAcknowledgeComponent, canActivate: [AuthGuard], data: { title: 'Acknowledge' } },
      { path: 'acknowledge/:id/:query', component: SfIcdAcknowledgeComponent,  data: { title: 'Acknowledge' } },

      { path: 'icdmore1', component: SfIcdMoveLocationComponent, canActivate: [AuthGuard], data: { title: 'ICD More' } },
      { path: 'additional/:id', component: SfIcdAddlocationComponent, canActivate: [AuthGuard], data: { title: 'Additional Location' } },
      { path: 'additional/:id/:f/:dcode', component: SfIcdAddlocationComponent, canActivate: [AuthGuard], data: { title: 'Additional Location' } },

      { path: 'campmain/:id', component: SfIcdCampmaintainComponent, canActivate: [AuthGuard], data: { title: 'Camp maintain' } },
      { path: 'campmain/:id/:f/:dcode', component: SfIcdCampmaintainComponent, canActivate: [AuthGuard], data: { title: 'Camp maintain' } },

      { path: 'closeloc/:id', component: SfIcdCloselocationComponent, canActivate: [AuthGuard], data: { title: 'Close Location' } },
      { path: 'closeloc/:id/:f/:dcode', component: SfIcdCloselocationComponent, canActivate: [AuthGuard], data: { title: 'Close Location' } },

      { path: 'changeoffinfo/:id', component: SfIcdChangeOfficeInfoComponent, canActivate: [AuthGuard], data: { title: 'Change Office Info' } },
      { path: 'changeoffinfo/:id/:f/:dcode', component: SfIcdChangeOfficeInfoComponent, canActivate: [AuthGuard], data: { title: 'Change Office Info' } },

      { path: 'hubmaintain/:id', component: SfIcdHubMaintainComponent, canActivate: [AuthGuard], data: { title: 'Hub Maintain' } },
      { path: 'hubmaintain/:id/:f/:dcode', component: SfIcdHubMaintainComponent, canActivate: [AuthGuard], data: { title: 'Hub Maintain' } },

      { path: 'closeicd/:id', component: SfIcdTerminateContractComponent, canActivate: [AuthGuard], data: { title: 'Close ICD' } },
      { path: 'closeicd/:id/:f/:dcode', component: SfIcdTerminateContractComponent, canActivate: [AuthGuard], data: { title: 'Close ICD' } },

      { path: 'moveloc/:id', component: SfIcdMoveLocationComponent, canActivate: [AuthGuard], data: { title: 'Move Location' } },
      { path: 'moveloc/:id/:f/:dcode', component: SfIcdMoveLocationComponent, canActivate: [AuthGuard], data: { title: 'Move Location' } },

      { path: 'reopenicd/:id', component: SfIcdReopenicdComponent, canActivate: [AuthGuard], data: { title: 'Reopen ICD' } },
      { path: 'reopenicd/:id/:f/:dcode', component: SfIcdReopenicdComponent, canActivate: [AuthGuard], data: { title: 'Reopen ICD' } },

      { path: 'inactiveoffice/:id', component: SfIcdInactiveComponent, canActivate: [AuthGuard], data: { title: 'Inactive Office (Retrain)' } },
      { path: 'inactiveoffice/:id/:f/:dcode', component: SfIcdInactiveComponent, canActivate: [AuthGuard], data: { title: 'Inactive Office (Retrain)' } },

      
      {
        path: 'icdmore', component: SfIcdMoreComponent, canActivate: [AuthGuard], data: { title: 'ICD More' },
        children: [
          { path: '', redirectTo: 'icdinfo', pathMatch: 'full' },
          
        ],
      },
      
      
      // add more child routes for other tabs if needed
    ],
     data: { title: 'ICD Detail' }
  },
  
    { path: 'about', component: AboutComponent, data: { title: 'About Us' } },
    {
        path: 'netsuiteledger',
        component: NetsuiteLedgerComponent,
        canActivate: [AuthGuard],
        data: { title: 'NetSuite Ledger' }
    },
  { path: 'home', redirectTo: '/', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent, data: { title: 'Page Not Found' } }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    enableTracing: false
  })],
  exports: [RouterModule],
  providers: [
    AuthService,
    AuthGuard,
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }]
})
export class AppRoutingModule { }
